import {cloneDeep} from 'lodash';
import Vue from "vue";

export default class InfluencerCartItem {
    socialNetworkAccounts;

    constructor(influencerId, username, profilePictureUrl, socialNetworkAccounts) {
        this.influencerId = influencerId;
        this.username = username;
        this.profilePictureUrl = profilePictureUrl;
        this.socialNetworkAccounts = socialNetworkAccounts;
        this.pricePackageCartItems = {};
    }

    containsPricePackageCartItem(pricePackageId) {
        return this.pricePackageCartItems.hasOwnProperty(pricePackageId)
    }

    putPricePackageCartItem(pricePackageCartItem) {
        Vue.set(this.pricePackageCartItems, pricePackageCartItem.pricePackage._id, pricePackageCartItem)
    }

    getPricePackageCartItem(pricePackageId) {
        return this.pricePackageCartItems[pricePackageId];
    }

    getActiveSocialNetworks() {
        const activeSocialNetworks = {}
        for (let pricePackageCartItem of Object.values(this.pricePackageCartItems)) {
            for (let pricePackageItem of pricePackageCartItem.pricePackage.price_package_items) {
                if (activeSocialNetworks.hasOwnProperty(pricePackageItem.social_network)) {
                    continue;
                }

                let socialNetworkAccount = this.socialNetworkAccounts[pricePackageItem.social_network];
                activeSocialNetworks[pricePackageItem.social_network] = {
                    socialNetwork: pricePackageItem.social_network,
                    username: socialNetworkAccount ? socialNetworkAccount.username : this.username
                }
            }
        }

        return Object.values(activeSocialNetworks)
    }
}
